<!-- 外部リンクに関する情報を持っていたらリンクを表示 -->
<template>
  <a class="button" @click="goToExternalLink(url)">
    {{ title }}
  </a>
</template>

<script>
export default {
  name: "ExternalLinkButton",
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  display: block;
  border-radius: 4px;
  padding: 15px;
  padding-right: 30px;
  font-size: 14px;
  font-weight: bold;
  background-color: #fae278;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  background-image: url("~@/assets/img//arrow/svg/arow-right-black.svg");
  background-repeat: no-repeat;
  background-position: calc(100% - 12px) center;
  background-size: 8px;
  color: #000000;
  border-radius: 10px;
}

.button:hover,
.button:active,
.button:focus {
  text-decoration: none;
}
</style>
>
